// import { useEffect, useRef, useState } from "react";
// import api from "../api/axios";
// import "../css/displayBoard.css";

// function DisplayBoardCounterWise() {
//   const [currentList, setCurrentList] = useState([]);
//   const [queue, setQueue] = useState([]);

//   const lastSpeakRef = useRef("");

//   const loadData = async () => {
//     try {
//       // 🔥 IMPORTANT: Backend should return ARRAY
//       const currentRes = await api.get("/Token/current-by-counter");
//       const queueRes = await api.get("/Token/queue");

//       setCurrentList(currentRes.data || []);
//       setQueue(queueRes.data || []);
//     } catch (error) {
//       console.log("API Error:", error);
//     }
//   };

//   useEffect(() => {
//     loadData();
//     const interval = setInterval(loadData, 3000);
//     return () => clearInterval(interval);
//   }, []);

//   // 🔊 Voice Announcement (latest token only)
//   useEffect(() => {
//     if (!currentList.length) return;

//     const latest = currentList[0];

//     const speakKey = `${latest.tokenNo}-${latest.counterId}`;

//     if (lastSpeakRef.current === speakKey) return;

//     lastSpeakRef.current = speakKey;

//     setTimeout(() => {
//       window.speechSynthesis.cancel();

//       const speech = new SpeechSynthesisUtterance(
//         `ध्यान दें, टोकन नंबर ${latest.tokenNo}, कृपया काउंटर नंबर ${latest.counterId} पर जाएं।`
//       );

//       speech.lang = "hi-IN";
//       speech.volume = 1;
//       speech.rate = 0.85;
//       speech.pitch = 1;

//       window.speechSynthesis.speak(speech);
//     }, 500);
//   }, [currentList]);

//   return (
//     <div className="board-container">

//       {/* LEFT SIDE - NOW SERVING */}
//       <div className="left-panel">

//         <div className="title">NOW SERVING</div>

//         {currentList.length > 0 ? (
//           <div className="counter-grid">
//             {currentList.map((c) => (
//               <div className="counter-card" key={c.counterId}>
//                 <div className="token">{c.tokenNo}</div>
//                 <div className="counter">Counter {c.counterId}</div>
//                 <div className="name">{c.customerName}</div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div className="no-data">No Token Serving</div>
//         )}

//       </div>

//       {/* RIGHT SIDE - QUEUE */}
//       <div className="right-panel">

//         <div className="queue-title">WAITING QUEUE</div>

//         <div className="queue-list">
//           {queue.length > 0 ? (
//             queue.map((t) => (
//               <div className="queue-item" key={t.id}>
//                 <span className="q-token">{t.tokenNo}</span>
//                 <span className="q-counter">Counter {t.counterId}</span>
//               </div>
//             ))
//           ) : (
//             <div className="no-queue">No Waiting Token</div>
//           )}
//         </div>

//       </div>

//     </div>
//   );
// }

// export default DisplayBoardCounterWise;

import { useEffect, useRef, useState } from "react";
import api from "../api/axios";
import "../css/displayBoard.css";

function DisplayBoardCounterWise() {
  const [currentList, setCurrentList] = useState([]);
  const [queue, setQueue] = useState([]);

  // store already spoken tokens
  const spokenRef = useRef(new Set());

  // ---------------- LOAD DATA ----------------
  const loadData = async () => {
    try {
      const currentRes = await api.get("/Token/current-by-counter");
      const queueRes = await api.get("/Token/queue");

      setCurrentList(currentRes.data || []);
      setQueue(queueRes.data || []);
    } catch (error) {
      console.log("API Error:", error);
    }
  };

  // ---------------- AUTO REFRESH ----------------
  useEffect(() => {
    loadData();

    const interval = setInterval(loadData, 3000);
    return () => clearInterval(interval);
  }, []);

  // ---------------- VOICE SYSTEM ----------------
  useEffect(() => {
    if (!currentList.length) return;

    currentList.forEach((item) => {
      const key = `${item.tokenNo}-${item.counterId}`;

      // already spoken → skip
      if (spokenRef.current.has(key)) return;

      spokenRef.current.add(key);

      setTimeout(() => {
        window.speechSynthesis.cancel();

        const speech = new SpeechSynthesisUtterance(
          `ध्यान दें, टोकन नंबर ${item.tokenNo}, कृपया काउंटर नंबर ${item.counterId} पर जाएं।`,
        );

        speech.lang = "hi-IN";
        speech.volume = 1;
        speech.rate = 0.85;
        speech.pitch = 1;

        window.speechSynthesis.speak(speech);
      }, 500);
    });
  }, [currentList]);

  //   const s = new SpeechSynthesisUtterance("Testing");

  // s.onstart = () => console.log("start");
  // s.onend = () => console.log("end");
  // s.onerror = e => console.log(e);

  // speechSynthesis.speak(s);

  // ---------------- UI ----------------
  return (
    <>
      <style>
        {`
        .navbar,.kds-2{display: none !important;}
        `}
      </style>

      {/* <button
    onClick={() => {
        speechSynthesis.resume();
        alert("Voice Enabled");
    }}
>
    Enable Voice
</button>  */}
      <div className="board-container">
        {/* LEFT SIDE */}
        <div className="left-panel">
          <div className="title">NOW SERVING</div>

          {currentList.length > 0 ? (
            <div className="counter-grid">
              {currentList.map((c) => (
                <div className="counter-card" key={c.counterId}>
                  <div className="token">{c.tokenNo}</div>

                  <div className="counter">Counter {c.counterId}</div>

                  <div className="name">{c.customerName}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-data">
              {/* No Token Serving
            https://www.youtube.com/embed/Hys7hMRhHFo?si=ZGLAUhXPsj2E-wHd
            */}
              <iframe
                width="100%"
                height="420"
                src="https://www.youtube.com/embed/6mMwRqjAkHA?si=GeK6HIgPsJcW3TsT?autoplay=1&mute=1"
                title="YouTube video player"
                frameborder="0"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          )}
        </div>

        {/* RIGHT SIDE */}
        <div className="right-panel">
          <div className="queue-title">WAITING QUEUE</div>

          <div className="queue-list">
            {queue.length > 0 ? (
              queue.map((t) => (
                <div className="queue-item" key={t.id}>
                  <span className="q-counter">Counter - {t.counterId}</span>
                  <span className="q-token">{t.tokenNo}</span>
                </div>
              ))
            ) : (
              <div className="no-queue">No Waiting Token</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default DisplayBoardCounterWise;
